type CreatedDateRangeFilter = {
	FromDate?: Date | null;
	ToDate?: Date | null;
};

export function transformDateRangeFilter<TFilter extends CreatedDateRangeFilter>(filter?: Partial<TFilter>): Partial<TFilter> | undefined {
	if (!filter)
		return filter;

	return {
		...filter,
		FromDate: filter.FromDate
			? new Date(filter.FromDate.getFullYear(), filter.FromDate.getMonth(), filter.FromDate.getDate())
			: filter.FromDate,
		ToDate: filter.ToDate
			? new Date(filter.ToDate.getFullYear(), filter.ToDate.getMonth(), filter.ToDate.getDate() + 1)
			: filter.ToDate
	};
}
